require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2012-01-05-dreadnot-continuous-deployment.json") })
        }
      }, "path---articles-2012-01-05-dreadnot-continuous-deployment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2012-01-05-dreadnot-continuous-deployment!./.cache/json/articles-2012-01-05-dreadnot-continuous-deployment.json
// module id = 616
// module chunks = 231608221292675